export default "* Fiskeredskab\n* Fiskespyd\n* Fisk\n";